<template>
    <b-overlay :show="inventoryDataLoading" opacity="0.2" rounded="sm">
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>
        <b-card no-body>
                    
            <b-tabs pills nav-class="m-1" active-nav-item-class="nav-pill-secondary" content-class="border-top">
                <b-tab title="Genel Bilgiler" >
                    <form-wizard color="#1F4690" :title="null" :subtitle="null" shape="square" layout="vertical" class="wizard-vertical shadow-none">
                        <tab-content title="Araç">
                            <inventory-vehicle ref="vehicle" :editing="editing" v-model="inventory.VehicleInventory"></inventory-vehicle>
                        </tab-content>
                        <tab-content title="Ruhsat">
                            <inventory-permit ref="permit" v-model="inventory.VehicleInventoryPermit"></inventory-permit>
                        </tab-content>
                        <tab-content title="Finansal Bilgiler">
                            <inventory-financial ref="financial" v-model="inventory.VehicleInventory"></inventory-financial>
                        </tab-content>
                        <template #finish>
                            <v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer> 
                        </template>
                        <template #prev>
                            <button class="btn btn-outline-primary">
                                <feather-icon icon="ChevronLeftIcon" class="mr-50"></feather-icon>
                                Önceki
                            </button>
                        </template>
                        <template #next>
                            <button class="btn btn-primary">
                                Sonraki
                                <feather-icon icon="ChevronRightIcon" class="ml-50"></feather-icon>
                            </button>
                        </template>
                    </form-wizard>
                </b-tab>
                <b-tab title="Belgeler" v-if="id != 0 || id != '0'">
                    <inventory-document :id="id"></inventory-document>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-overlay>
</template>

<script>
import { FormWizard,TabContent } from "vue-form-wizard"
import { BOverlay,BTabs,BTab,BCard } from "bootstrap-vue"
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import InventoryVehicle from './components/InventoryVehicle.vue'
import InventoryPermit from './components/InventoryPermit.vue'
import InventoryDocument from './components/InventoryDocument.vue'
import InventoryFinancial from './components/InventoryFinancial.vue'
import VehicleOperationsApi from '@/api/vehicle-operations'
import moment from 'moment'

export default {
    components:{
        FormWizard,
        TabContent,
        InventoryVehicle,
        InventoryPermit,
        InventoryDocument,
        InventoryFinancial,
        BOverlay,
        BTabs,
        BTab,
        BCard
    },
    data(){
        return{
            loading:false,
            inventoryDataLoading:false,
            editing: this.$route.params.id != 0 || this.$route.params.id != '0' ? true : false,
            id: this.$route.params.id,
            inventory:{
                VehicleInventory:{
                    Id:null,
                    VehicleId:null,
                    VehiclePlateId:null,
                    WorkingGroupId:null,
                    ColourId:null,
                    FirmId:null,
                    FirmName:null,
                    MortgageIsActive:false,
                    MortgageBankId:null,
                    MortgageStartDate:null,
                    MortgageEndDate:null,
                    KmOnDateOfPurchase:null,
                    InvoicePurchaseDate:null,
                    PurchaseCurrencyUnitId:null,
                    Price:null,
                    CurrencyRate:null,
                    ConvertedPrice:null,
                    AllowCurrencyRateChange:true,
                    CurrencyDate:moment().format("YYYY-MM-DD")
                },
                VehicleInventoryPermit:{
                    Id:null,
                    ProvinceId:null,
                    DistrictId:null,
                    ColourId:null,
                    FirstRegistrationDate:null,
                    RegistrationOrderNo:null,
                    RegistrationDate:null,
                    MotorNo:null,
                    ChasisNo:null,
                    DocumentNo:null,
                },
            },
        }
    },
    mounted(){
        this.getInventoryData()
    },
    methods:{
        back(){
            this.$router.push({name:'vehicle-inventory-definition'})
        },
        async createOrUpdate(){
            let data = structuredClone(this.inventory) 
            data.VehicleInventory.CurrencyRate = Number(data.VehicleInventory.CurrencyRate.replaceAll('.','').replace(',','.')) || null
            data.VehicleInventory.Price = Number(data.VehicleInventory.Price.replaceAll('.','').replace(',','.')) || null
            data.VehicleInventory.ConvertedPrice = Number(data.VehicleInventory.ConvertedPrice?.replaceAll('.','').replace(',','.')) || null
            this.loading = true
            VehicleOperationsApi.Inventory.CreateOrUpdate(this.editing,data).then(response=>{
                this.$result(response)
                this.loading = false
                if(response.data.Success){
                    this.$router.push({name:'vehicle-inventory-definition'})
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        getInventoryData(){
            if(this.id != "0" || this.id != 0){
                this.inventoryDataLoading = true
                VehicleOperationsApi.Inventory.GetById(this.id)
                .then(response => {
                    this.inventory.VehicleInventory.Id = response.data.Data.VehicleInventory.Id
                    this.inventory.VehicleInventory.VehicleId = response.data.Data.VehicleInventory.VehicleId
                    this.$refs.vehicle.getPlates(response.data.Data.VehicleInventory.VehiclePlateId).then(()=>{
                        this.inventory.VehicleInventory.VehiclePlateId = response.data.Data.VehicleInventory.VehiclePlateId
                    })
                    this.inventory.VehicleInventory.MortgageIsActive=response.data.Data.VehicleInventory.MortgageIsActive
                    this.inventory.VehicleInventory.MortgageBankId=response.data.Data.VehicleInventory.MortgageBankId
                    this.inventory.VehicleInventory.MortgageStartDate=response.data.Data.VehicleInventory.MortgageStartDate
                    this.inventory.VehicleInventory.MortgageEndDate=response.data.Data.VehicleInventory.MortgageEndDate
                    this.inventory.VehicleInventory.KmOnDateOfPurchase=response.data.Data.VehicleInventory.KmOnDateOfPurchase
                    this.inventory.VehicleInventory.InvoicePurchaseDate=response.data.Data.VehicleInventory.InvoicePurchaseDate
                    this.inventory.VehicleInventory.PurchaseCurrencyUnitId=response.data.Data.VehicleInventory.PurchaseCurrencyUnitId
                    this.inventory.VehicleInventory.Price=response.data.Data.VehicleInventory.Price
                    this.inventory.VehicleInventory.FirmId=response.data.Data.VehicleInventory.FirmId
                    this.inventory.VehicleInventory.FirmName=response.data.Data.VehicleInventory.FirmName
                    this.inventory.VehicleInventory.ConvertedPrice=response.data.Data.VehicleInventory.ConvertedPrice
                    this.inventory.VehicleInventory.CurrencyDate=response.data.Data.VehicleInventory.CurrencyDate
                    this.inventory.VehicleInventory.CurrencyRate=response.data.Data.VehicleInventory.CurrencyRate
                    this.inventory.VehicleInventory.WorkingGroupId = response.data.Data.VehicleInventory.WorkingGroupId
                    this.$refs.vehicle.getWorkingGroups().then(()=>{
                        this.inventory.VehicleInventory.VehiclePlateId = response.data.Data.VehicleInventory.VehiclePlateId
                        if(response.data.Data.VehicleInventory.FirmName && response.data.Data.VehicleInventory.FirmId){
                            this.$refs.vehicle.searchFirms(response.data.Data.VehicleInventory.FirmName)
                        }
                    })
                    this.inventory.VehicleInventory.ColourId = response.data.Data.VehicleInventory.ColourId
                    this.inventory.VehicleInventoryPermit.Id = response.data.Data.VehicleInventoryPermit.Id
                    this.inventory.VehicleInventoryPermit.ProvinceId = response.data.Data.VehicleInventoryPermit.ProvinceId
                    this.$refs.permit.getDistricts().then(()=>{
                        this.inventory.VehicleInventoryPermit.DistrictId = response.data.Data.VehicleInventoryPermit.DistrictId
                    })
                    this.inventory.VehicleInventoryPermit.FirstRegistrationDate = response.data.Data.VehicleInventoryPermit.FirstRegistrationDate
                    this.inventory.VehicleInventoryPermit.RegistrationOrderNo = response.data.Data.VehicleInventoryPermit.RegistrationOrderNo
                    this.inventory.VehicleInventoryPermit.RegistrationDate = response.data.Data.VehicleInventoryPermit.RegistrationDate
                    this.inventory.VehicleInventoryPermit.MotorNo = response.data.Data.VehicleInventoryPermit.MotorNo
                    this.inventory.VehicleInventoryPermit.ChasisNo = response.data.Data.VehicleInventoryPermit.ChasisNo
                    this.inventory.VehicleInventoryPermit.DocumentNo = response.data.Data.VehicleInventoryPermit.DocumentNo
                    this.inventoryDataLoading = false
                }).catch(err=>{
                    this.inventoryDataLoading = false
                })
            }
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
